module.exports = __webpack_public_path__ + "static/treatwell-6cc139ac5ac34bc09713ea3a0b731ecf.png";